import React from 'react';

import { di } from 'react-magnetic-di';

import { Box } from '@atlaskit/primitives/compiled/box';
import Textfield from '@atlaskit/textfield/text-field';

import { asFormNumberField } from '../../../../../../../../common/types/form/form-fields/utils';
import type { FormFieldComponentRendererProps } from '../../../../../../../../common/types/renderers';
import { useFormField } from '../../../../../../../../controllers/form-renderer-store';

export const PreviewNumberInput = ({
	fieldId,
	fieldInputId,
}: FormFieldComponentRendererProps): React.JSX.Element => {
	di(useFormField);
	const formField = useFormField({ fieldId });
	const formNumberField = asFormNumberField(formField);

	if (formNumberField === undefined) {
		return <></>;
	}

	return (
		<Box testId={`field-input-number-preview-${fieldId}`}>
			<Textfield id={fieldInputId} value={formNumberField.value?.number} isDisabled width="small" />
		</Box>
	);
};
